import React from 'react';

import styles from './ListItem.module.scss';
import Image from '../Image/Image';
import { AppData } from './listUtils';
import { formatPrice, getAvailabilitySlug, ucFirst } from '../../utils';
import { App } from '../../generated/graphql';

type AppTile = {
  appData: AppData;
  isLoading: boolean | undefined;
  availabilityType: string;
};
export const AppTile: React.FC<AppTile> = ({ appData, isLoading, availabilityType }) => {
  const { appMediaUrl, name, availability } = appData;

  if (appMediaUrl?.startsWith('+')) {
    return (
      <li>
        <div className={styles.GhostIcon} data-testid="list-item-logos-ghost-icon">
          {appMediaUrl}
        </div>
      </li>
    );
  }
  return (
    <li>
      <Image
        fallbackUrl="/Images/NoApp.png"
        className={availability === 'unavailable' ? 'Unavailable' : ''}
        isLoading={isLoading}
        src={appMediaUrl}
        alt={`${name} - ${availabilityType}`}
      />
    </li>
  );
};

type AppAvailability = {
  app: App;
  availability: string;
};
export const AppAvailability: React.FC<AppAvailability> = ({ app, availability }) => (
  <>
    <Image
      src={app.image || '/Images/NoApp.png'}
      fallbackUrl="/Images/NoApp.png"
      alt={`${app.name} - ${availability}`}
    />
    <div>
      <span>{app.name}</span>
      <span>
        {availability === 'unsupported' ? (
          <i className={`mm-error-circle ${styles.UnsupportedIcon}`} />
        ) : (
          <i className={`Dot ${getAvailabilitySlug(availability)}`} />
        )}
        {ucFirst(availability)}
      </span>
    </div>
  </>
);

type AppPriceProps = {
  app: App;
  availability: string;
  price?: number | null;
};

export const AppPrice: React.FC<AppPriceProps> = ({ app, availability, price }) => (
  <>
    <Image
      src={app.image || '/Images/NoApp.png'}
      fallbackUrl="/Images/NoApp.png"
      alt={`${app.name} - price list - ${availability}`}
    />
    <span>{formatPrice(price)}</span>
  </>
);
